import React, {useEffect, useRef, useState} from "react";
import {Button} from "react-bootstrap";
import {CircularProgress, TextField} from "@material-ui/core";
// eslint-disable-next-line no-restricted-imports
import {makeStyles} from "@material-ui/core/styles";
import AlertComponent from "_metronic/_helpers/AlertComponent";
import {shallowEqual, useSelector} from "react-redux";

const useStyles = makeStyles({
    progressRoot: {
        width: "100%",
        padding: "32px 16px",
    },
    progress: {
        margin: "auto",
        display: "block",
        color: "#e2241b",
    },
});

const Ticket = ({
                    onTicket,
                    barcode,
                    onBarcode,
                    isLoading,
                    errMsg,
                    isError,
                    setBarcode,
                    errorBarcode,
                    setShowVoidTicket,
                    isSubmitting
                }) => {
    const classes = useStyles();

    const inputRef = useRef(null);
    const [isFocused, setIsFocused] = useState(false);

    const {afterPrintTrigger} = useSelector(state => state.ticket, shallowEqual);

    useEffect(() => {
        const handleKeyPress = (event) => {
            if(!isSubmitting) {
                setShowVoidTicket(false);
                inputRef.current.focus();

                if (event.key !== "Enter" && !isFocused) {
                    setBarcode(event.key);
                }
            }
        };

        if (isFocused) {
            document.removeEventListener("keyup", handleKeyPress);
        } else {
            document.addEventListener("keyup", handleKeyPress);
        }

        return () => {
            document.removeEventListener("keyup", handleKeyPress);
        };
    }, [barcode, isFocused, isSubmitting]);

    useEffect(() => {
        inputRef.current.focus()
    },[afterPrintTrigger])

    return (
        <div className="d-flex flex-column align-items-center w-100 p-4">
            <div className="pr-4 w-50">
                <form
                    className="pb-4 d-flex"
                    onSubmit={(e) => {
                        e.preventDefault();
                        onTicket(barcode);
                        setIsFocused(false);
                    }}
                >
                    <TextField
                        fullWidth
                        id="barcode"
                        name="barcode"
                        label="Barkodu daxil et"
                        placeholder="Barkodu daxil et"
                        value={barcode}
                        onChange={onBarcode}
                        inputRef={inputRef}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        disabled={isSubmitting}
                    />
                    <Button disabled={isSubmitting} variant="info" type="submit">
                        Axtar
                    </Button>
                </form>

                {errorBarcode && (
                    <div>
                        <AlertComponent
                            variant="danger"
                            message="Barkodu düzgün daxil edin"
                        />
                    </div>
                )}
                {isError && (
                    <div>
                        <AlertComponent variant="info" message={errMsg}/>
                    </div>
                )}
            </div>
            {isLoading ? (
                <div className={classes.progressRoot}>
                    <CircularProgress className={classes.progress}/>
                </div>
            ) : (
                ""
            )}
        </div>
    );
};

export default Ticket;
